
        export default {
          mounted() {
            // Das Flag sitzt auf <html>, nicht auf dem Hook-Element: LiveView räumt
            // beim Patchen fremde Attribute im gerenderten Baum weg, und ein Tick
            // oder ein kommender Mitspieler würde die Geste sonst mittendrin killen.
            // `data-theme` daneben folgt derselben Logik.
            this.root = document.documentElement
            this.reduced = matchMedia("(prefers-reduced-motion: reduce)")
            this.spring = {x: 0, v: 0, dir: -1, raf: null, t: 0}
            this.handleEvent("pet:react", ({action}) => this.react(action))

            // Streicheln (RFC 0024) ist die einzige Geste, die man *wiederholt*
            // macht — und die einzige, für die eine feste Keyframe-Kurve zu wenig
            // ist: der zweite Tap kommt, während der erste noch läuft, und eine
            // Animation, die dabei von vorn anfängt, fühlt sich an wie ein Knopf,
            // nicht wie ein Tier. Also eine echte Feder: jeder Tap gibt Impuls
            // dazu, das Tier lehnt sich weiter, je schneller man streichelt, und
            // kommt von allein zur Ruhe.
            //
            // Der Impuls sitzt hier und nicht am Server: das Tier soll unter dem
            // Finger antworten, nicht nach dem Roundtrip. Was der Server macht
            // (Chronik, Broadcast an den anderen Menschen), läuft unverändert
            // weiter — nur die eigene Geste wartet nicht mehr darauf.
            //
            // Delegiert statt am Knopf: LiveView tauscht das Sprite bei jedem
            // Patch aus, ein Listener direkt darauf wäre nach dem ersten Tick weg.
            this.onPress = event => {
              if (event.target.closest(".pet-sprite")) this.nudge()
            }
            this.el.addEventListener("pointerdown", this.onPress)
          },

          // Impuls, alternierend: zweimal in dieselbe Richtung wäre ein Stoß,
          // abwechselnd ist es ein Wiegen. Die Geschwindigkeit ist gedeckelt,
          // sonst dreht sich ein hektisch gestreicheltes Tier aus dem Bild.
          nudge() {
            if (this.reduced.matches) return
            // Ein schlafendes Tier wackelt nicht, es schnauft (RFC 0024) — die
            // Feder bleibt stehen, und `cuddle_asleep` vom Server spielt seine
            // eigene Geste. `data-night` sitzt am Hook-Element selbst.
            if (this.el.dataset.night === "true") return

            const s = this.spring
            s.dir = -s.dir
            s.v = Math.max(-190, Math.min(190, s.v + 76 * s.dir))

            // Solange die Feder läuft, ist die eigene Geste schon zu sehen — die
            // CSS-Keyframes, die derselbe Klick über den Server zurückbringt,
            // würden sie überschreiben. Der andere Mensch sieht sie weiterhin.
            this.cuddling = true
            clearTimeout(this.cuddleTimer)
            this.cuddleTimer = setTimeout(() => (this.cuddling = false), 900)

            if (!s.raf) {
              s.t = 0
              s.raf = requestAnimationFrame(now => this.integrate(now))
            }
          },

          // Gedämpfter harmonischer Oszillator, explizit integriert. `dt` ist
          // gedeckelt: ein Tab-Wechsel liefert sonst einen Sprung von Sekunden
          // und die Feder explodiert.
          integrate(now) {
            const s = this.spring
            const dt = s.t ? Math.min(0.032, (now - s.t) / 1000) : 0.016
            s.t = now

            // Steifigkeit 150, Daempfung 10.5: eine Periode von rund einer halben
            // Sekunde und zwei sichtbare Ausschlaege, bevor es steht — dieselbe
            // Amplitude (etwa 3 Grad) und derselbe Rhythmus wie die
            // Keyframe-Geste, die sie ersetzt (`pet-cuddle`, RFC 0024). Die Feder
            // bringt nicht mehr Bewegung, sie bringt Masse.
            s.v += (-150 * s.x - 10.5 * s.v) * dt
            s.x += s.v * dt

            if (Math.abs(s.x) < 0.02 && Math.abs(s.v) < 0.05) {
              this.settle()
              return
            }

            // Auf <html>, aus demselben Grund wie `data-pet-react`: ein Style am
            // gepatchten Element wäre beim nächsten Diff weg. Custom Properties
            // erben, das Sprite liest sie in app.css.
            this.root.style.setProperty("--pet-lean", s.x.toFixed(3))
            this.root.style.setProperty("--pet-squish", (Math.abs(s.x) * 0.011).toFixed(4))
            s.raf = requestAnimationFrame(next => this.integrate(next))
          },

          settle() {
            const s = this.spring
            s.x = 0
            s.v = 0
            s.t = 0
            if (s.raf) cancelAnimationFrame(s.raf)
            s.raf = null
            this.root.style.removeProperty("--pet-lean")
            this.root.style.removeProperty("--pet-squish")
          },

          react(action) {
            // Siehe `nudge()`: die eigene Feder läuft schon.
            if (this.cuddling && (action === "cuddle" || action === "cuddle_asleep")) return

            clearTimeout(this.resetTimer)
            this.root.removeAttribute("data-pet-react")
            // Reflow erzwingen, sonst startet dieselbe Animation bei zwei schnellen
            // Klicks nicht neu, sondern läuft einfach unbeeindruckt weiter.
            void this.root.offsetWidth
            this.root.setAttribute("data-pet-react", action)
            // 700ms decken jede Geste ab — außer der Enthüllung (RFC 0028), die
            // 1400ms läuft und sonst mittendrin abgerissen würde. Kein Wert je
            // Geste: eine einzige weicht ab, und eine Tabelle für einen Ausreißer
            // ist eine Tabelle zu viel.
            const ms = action === "grow_up" ? 1400 : 700
            this.resetTimer = setTimeout(() => this.root.removeAttribute("data-pet-react"), ms)
          },

          destroyed() {
            clearTimeout(this.resetTimer)
            clearTimeout(this.cuddleTimer)
            this.el.removeEventListener("pointerdown", this.onPress)
            this.settle()
            this.root.removeAttribute("data-pet-react")
          }
        }
      